import React, { Component } from "react";
import axios from 'axios';
import api from '../common/api';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import InputAdornment from '@material-ui/core/InputAdornment';
import Typography from '@material-ui/core/Typography';
import { Container, Row, Col } from "shards-react";
import { withStyles } from "@material-ui/core/styles";
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import NumberFormat from 'react-number-format';
import Input from '@material-ui/core/Input';
import InputMask from 'react-input-mask';
import Select from '@material-ui/core/Select';
import Button from '@material-ui/core/Button';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import MenuItem from '@material-ui/core/MenuItem';
import MediaFile from '../../components/common/MediaFile'

const useStyles = theme => ({
    root: {
      flexGrow: 1,
      width: '100%',
    },
      appBar: {
      position: 'relative',
    },
    title: {
      marginLeft: '2rem',
      flex: 1,
      color: 'white'
    },
    paper: {
      padding: '2rem',
      textAlign: 'center',
    },
    checkedIcon:{
        width: 16,
        height: 16,
    },
    option:{
          fontWeight: 600,
        fontSize:'0.75rem',
    },
    typography:{
        fontSize: '0.75rem'
    },
    menu:{
        fontSize: '0.75rem'
    },
    select:{
        marginTop: '8px',
        marginRight:'8px'
    }
  
  });

  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }
    
  function TextMaskCustom(props) {
    const { inputRef, ...other } = props;
  
    return (
      <InputMask
        {...other}
        ref={ref => {
          inputRef(ref ? ref.inputElement : null);
        }}
        mask={[/[A-C,a,c]/, '-', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]}
        //maskPlaceholder={'0'}
        //showMask
        alwaysShowMask={false}
        autoComplete={false}
        showMask={false}
        
      />
    );
  }
  
    
class MultipleVoucher extends React.Component {


    constructor(props) {
        super(props);
        this.state = {
                providers:{provider:{business_name:''}, options:[], loading: false},
                work_orders:[],
                iva_conditions:{buy:[]},
                voucher_types:[],
                search: false,
                snackbar:{open:false, severity: ''},
                voucher:{created_at: new Date().toISOString().slice(0, 10)},
                payment_deals:[],
                files:[],
                payment_deal:0,
                payment_deal_hansa_code:'',
                provider_payment_deal: 0,
          }
    }

    async componentDidMount() {
    	await this.getVoucherTypes()
    	await this.getDropdowns()
    	await this.getPaymentsDeals()
    }

    getPaymentsDeals = () => {
		const token = localStorage.getItem('userToken')
		axios.get(api.payment_deals,{ headers: {"Authorization" : `Bearer ${token}`} })
	      .then(res => {
	      		this.setState({payment_deals: res.data})
	      })
	      .catch(err =>{console.log(err)
	      })    	
    }


	getDropdowns = async () => {
	    let self = this
	    const token = localStorage.getItem('userToken')
	    await axios.get(api.dropdowns().ot(),
    		{headers: {'Content-Type': 'multipart/form-data',"Authorization" : `Bearer ${token}`}}
	       )
	      .then((response)=> {
	      		var res = response.data
	      		var iva_conditions = res.iva_conditions
	      		this.setState({iva_conditions: iva_conditions})
	      })
	      .catch(function (error) {
	    	console.log(error)
	    })
    }

    getVoucherTypes = () => {
		const token = localStorage.getItem('userToken')
		var voucher = this.state.voucher
		axios.get(api.voucher_types,{ headers: {"Authorization" : `Bearer ${token}`} })
	      .then(res => {
	      		var voucher_types = res.data
				if (voucher_types.length > 0 ){
					if (this.props.default_voucher_type_id){
						voucher.voucher_type_id = this.props.default_voucher_type_id
					} else {
						var voucher_type = voucher_types.filter(v => v.name === 'Factura')[0]
						voucher.voucher_type_id = (voucher_type) ? voucher_type.id : ''
					}
				}
	      		this.setState({voucher_types: voucher_types, voucher: voucher})
	      })
	      .catch(err =>{console.log(err)
	      })    	
    }


  
    handleSnackbar = (e) => {
    	e.preventDefault()
    	var snackbar = this.state.snackbar
    	snackbar.open = !snackbar.open
    	this.setState({snackbar: snackbar})
    }


    handleProvidersAsyncChange = async (event, values) =>{
		this.setState({loading: true})
    	var providers = this.state.providers
    	values = (values !== null) ? values :{business_name:''}
		providers.provider = values
    	this.setState({providers: providers})
        if (values.payment_deadline !== ''){
            var payment_deal = this.state.payment_deals.filter(p => p.name === values.payment_deadline)[0]
            payment_deal = (payment_deal) ? payment_deal.days_value : 0
            this.setState({payment_deal: payment_deal, provider_payment_deal: payment_deal, payment_deal_hansa_code: payment_deal})
        }
    	await this.getProviderPendingWorkOrders(providers.provider.id)
		this.setState({loading: false})
    }

    handleProvidersAsyncSearch = (event, values) =>{
    	var provider = values
		const token = localStorage.getItem('userToken')
		if (provider.length > 2) {
			return axios
		     .get(api.providers().index(1,provider,'','','',''),{ headers: {"Authorization" : `Bearer ${token}`} })
		      .then(res => {
		      		var providers = this.state.providers
		      		providers.options = res.data.data
		      		this.setState({providers: providers, search: false})
		      })
		      .catch(err =>{console.log(err)
		      })
		}
    }

    getProviderPendingWorkOrders = (provider_id) => {
		const token = localStorage.getItem('userToken')
		return axios
	     .get(api.providers().pendingToInvoice(provider_id),{ headers: {"Authorization" : `Bearer ${token}`} })
	      .then(res => {
	      		var work_orders = this.state.work_orders
	      		work_orders = res.data
	      		this.setState({work_orders: work_orders, search: true})
	      })
	      .catch(err =>{console.log(err)
	      })
    }

    handleExpand = (e,id) =>{
    	var work_orders = this.state.work_orders
    	work_orders[id]['expand'] = true
    	this.setState({work_orders: work_orders})
    }

    handleCollapse = (e,id) => {
    	var work_orders = this.state.work_orders
    	work_orders[id]['expand'] = false
    	this.setState({work_orders: work_orders})
    }
    
    handleTaskChange = (e,idx) => {
    	var work_orders = this.state.work_orders
		var element = e.target.name.split('.')
		var key = element[0]
		var id = element[1]
		if (key ==='checked'){
			work_orders[idx].tasks[id]['checked'] = e.target.checked
		} else {
			work_orders[idx].tasks[id][key] = e.target.value.replace('$','')
		}
		this.setState({work_orders: work_orders})
		this.doSubtotals(idx);	
    }

    doSubtotals = (id) => {
		var subtotals = {materials:0, workforce:0,total:0}
        var work_orders = this.state.work_orders;
	    var voucher = work_orders[id]
//		var voucher_related = this.state.voucher_related
	    for (var i=0; i < voucher.tasks.length; i++) {
	    	if (voucher.tasks[i].checked === true){
	    		voucher.tasks[i].materials_s_iva_price = (voucher.tasks[i].materials_s_iva_price !== null) ? (voucher.tasks[i].materials_s_iva_price) : 0
	    		voucher.tasks[i].workforce_s_iva_price = (voucher.tasks[i].workforce_s_iva_price !== null) ? (voucher.tasks[i].workforce_s_iva_price) : 0
	    		voucher.tasks[i].total_s_iva_price = (voucher.tasks[i].total_s_iva_price !== null) ? (voucher.tasks[i].total_s_iva_price) : 0
				if (voucher.tasks[i].workforce_s_iva_price > 0 || voucher.tasks[i].materials_s_iva_price > 0){
					subtotals.materials += (voucher.tasks[i].materials_s_iva_price) ? +parseFloat(voucher.tasks[i].materials_s_iva_price) : 0
					subtotals.workforce += (voucher.tasks[i].workforce_s_iva_price) ? +parseFloat(voucher.tasks[i].workforce_s_iva_price) : 0
					voucher.tasks[i].total_s_iva_price = +parseFloat(voucher.tasks[i].workforce_s_iva_price) + +parseFloat(voucher.tasks[i].materials_s_iva_price)
				} else {
					voucher.tasks[i].total_s_iva_price = +parseFloat(voucher.tasks[i].total_s_iva_price)
				}
		    	voucher.tasks[i].total_s_iva_price = Number((voucher.tasks[i].total_s_iva_price).toFixed(2));
		    	subtotals.total += +parseFloat(voucher.tasks[i].total_s_iva_price)
//				voucher_related.total_s_iva_price = +parseFloat(voucher.tasks[i].total_s_iva_price); 
//				voucher_related.total_s_iva_price = Number((voucher_related.total_s_iva_price).toFixed(2)); 
	    	}
	    }
	    voucher.subtotals = subtotals
        work_orders[id] = voucher        
	    this.setState({work_orders: work_orders})
//		this.setState({voucher_related:voucher_related})
  	}

    handleSubmit = (e) => {
        this.setState({saving: true})
        e.preventDefault();
        var formData = new FormData();
        var work_orders = this.state.work_orders
        var voucher = this.state.voucher
        var providers = this.state.providers
        var i = 0;
        work_orders.map((val,idx1)=>{
            val.tasks.map((val2,idx)=>{
                if (val2.checked){
                    formData.set("voucher["+i+"][work_order_id]", val.id);
                    formData.set("voucher["+i+"][voucher_type_id]", voucher.voucher_type_id);
                    formData.set("voucher["+i+"][number]", (voucher.number) ? voucher.number : '');
                    formData.set("voucher["+i+"][budget_id]", val.budget_to_invoice.id);
                    formData.set("voucher["+i+"][contact_id]", val.budget_to_invoice.provider.contact_id);
                    formData.set("voucher["+i+"][workforce_s_iva_price]", val2.workforce_s_iva_price);
                    formData.set("voucher["+i+"][materials_s_iva_price]", val2.materials_s_iva_price);
                    formData.set("voucher["+i+"][total_s_iva_price]", val2.total_s_iva_price);
                    formData.set("voucher["+i+"][due_date]", (voucher.due_date) ? voucher.due_date : '');
                    formData.set("voucher["+i+"][reception_date]", (voucher.reception_date) ? voucher.reception_date : '');
                    formData.set("voucher["+i+"][voucher_date]", (voucher.voucher_date) ? voucher.voucher_date : '');
                    formData.set("voucher["+i+"][all_tasks]", 0);
                    formData.set("voucher["+i+"][work_order_task_id]", (val2.id) ? val2.id : val2.id);
                    formData.set("voucher["+i+"][iva_buy_id]", (val2.iva_buy_id) ? val2.iva_buy_id : '');
                    i++;
                }
            })
        })
        i = 0;
        if (this.state.files){
            this.state.files.map((val, idx) => {
                if (val.file !== '' && val.file !== undefined){
                    formData.append("media["+i+"][file]", val.file[0])
                    i++;
                }	
            })
        }
        let self = this
        const token = localStorage.getItem('userToken')

        axios.post(api.vouchers().post(),
            formData,
            {headers: {'Content-Type': 'multipart/form-data',"Authorization" : `Bearer ${token}`}}
            )
            .then((response)=> {
                var snackbar = this.state.snackbar
                snackbar.open = true
                snackbar.severity = 'success'
                snackbar.success_message = 'Comprobante cargado con éxito'
                self.setState({snackbar:snackbar})
                self.setState({saving: false})
                self.setState({
                    voucher:{number:'', due_date:'',voucher_date:'', reception_date:''},
                    files:[]
                })
                work_orders.map((val,idx)=>{
                    val.tasks.map((val2,idx2)=>{
                        if (val2.checked){
                            work_orders[idx]['created'] = true
                        }
                    })
                })
                self.setState({
                    work_orders: work_orders,
                })
        
            })
            .catch(function (error) {
                    var error_message = ''
                    var errors = error.response.data
                if (errors.errors){
                    if (errors.errors.status_code !== 404){
                        var keys = Object.keys(errors.errors); 
                        for(var i = 0; i < keys.length; i++) {   
                        var key = (keys[i]) ; 
                        var key_errors = errors.errors[key]
                        key_errors.map((val,idx)=>{
                            error_message = error_message.concat(val).concat(' ')
                        })
                        }
                    } else {
                        error_message = 'Ha ocurrido un error. Contacte a su administrador'
                    }
                } else {
                    error_message = 'Ha ocurrido un error. Contacte a su administrador'
                }

                var snackbar = {open: true, success_message: error_message, severity: 'warning'}
                self.setState({ snackbar: snackbar})
                self.setState({saving: false})

        })
    
    }  

    handleChange = (e) => {
    	var voucher = this.state.voucher
		var payment_days_value = (this.state.payment_deal) ? this.state.payment_deal : 0

		if (e.target.name === 'voucher_date' || e.target.name === 'payment_deal'){
			if (e.target.name === 'payment_deal'){
				this.setState({payment_deal_hansa_code: e.target.value})
				var hansa_payment_deal = this.state.payment_deals.filter(p => p.hansa_code === e.target.value)[0]

				this.setState({payment_deal: hansa_payment_deal.days_value})
				payment_days_value = hansa_payment_deal.days_value
			} 
			if (e.target.name === 'voucher_date'){
				voucher.voucher_date = e.target.value
			}
			//var payment_days_value = (this.state.providers[0]) ? (this.state.providers[0].payment_deal) ? this.state.providers[0].payment_deal : 0 : 0
			var due_date = ''
			if (payment_days_value >= 0 && payment_days_value !== ''){
				due_date = new Date(voucher.voucher_date)

				if (due_date){
					due_date.setDate(due_date.getDate() + payment_days_value);
					if (!isNaN(due_date.getTime())) {
						voucher.due_date = due_date.toISOString().slice(0, 10)
					}
				}
			}
		} else {
			voucher[e.target.name] = e.target.value
		}
    	this.setState({voucher: voucher})
    }

	handleUploadFile = (file, meta_data) => {
		var files_state = this.state.files
		var file = {file: file, meta_data: meta_data}
		files_state.push(file)
		this.setState({files: files_state})
	}	

    autcompleteNumber = (e) => {
		var voucher = this.state.voucher
		var voucher_number = voucher.number.split("-")
		if (voucher_number.length === 3){
			voucher_number[0] = voucher_number[0].toUpperCase() 
			voucher_number[1] = voucher_number[1].replaceAll("_", "")
			voucher_number[2] = voucher_number[2].replaceAll("_", "")
			if (voucher_number[1].length > 0){
				voucher_number[1] = voucher_number[1].padStart(4,"0")
			}
			if (voucher_number[2].length > 0){
				voucher_number[2] = voucher_number[2].padStart(8,"0")
			}
			voucher.number = voucher_number.join("-")
			this.setState({voucher: voucher})
			//this.getVoucherByNumber();
		}
	}

    render() {
//        const work_orders = [1,2,3,4,5,6]
        const work_orders =[{id:123, type:'LAVADO', plate:'AC11'},{id:123, type:'LAVADO', plate:'AC11'},{id:123, type:'LAVADO', plate:'AC11'},{id:123, type:'LAVADO', plate:'AC11'},{id:123, type:'LAVADO', plate:'AC11'},{id:123, type:'LAVADO', plate:'AC11'}]
		const classes = this.props.classes;
		var payment_deal = (this.state.payment_deal) ? this.state.payment_deal : 0 

        return (
            <React.Fragment>
		        <Container fluid className="main-content-container px-4 position-relative">
    				<Row noGutters className="page-header">
                        <Typography variant="h6">Facturas a cargar</Typography>
                    </Row>
                    <div className="row">
                        <div className="col-md-12">
                        <Autocomplete
						      id="provider"
						      style={{ width: 200 }}
						      getOptionLabel={(option) => option.business_name}
							  getOptionSelected={(option, value) => option.business_name === value}			      
						      options={this.state.providers.options}
						      loading={this.state.providers.loading}
						      onInputChange={this.handleProvidersAsyncSearch}
						      onChange={this.handleProvidersAsyncChange.bind(this)}
							  //value={this.state.providers.options.find(v => v.business_name === this.state.providers.provider.business_name) || {}}
						      autoComplete
							  noOptionsText={<Typography variant="caption">Sin resultados</Typography>}
							  name="provider"
						      includeInputInList
						      className="mt-3 mr-2"
						      classes={{
					            option: classes.option,
			        		  }}
						      renderInput={(params) => (
						        <TextField
						          {...params}
						          placeholder="Ingrese un proveedor"
						          InputProps={{
						            ...params.InputProps,
						            endAdornment: (
						              <React.Fragment>
						                {params.InputProps.endAdornment}
						              </React.Fragment>
						            ),
						          }}
									InputLabelProps={{ ...params.InputLabelProps,
														shrink: true
													}}
									inputProps={{
									            ...params.inputProps,
									            style:{fontSize: '0.75rem', width: 70}
									          }}

						        />
						      )}
						    />
                        </div>
                        <div className="col-md-12">
                            <Input
                                id="number"
                                name="number"
                                label="Nro factura"
                                value={this.state.voucher.number}
                                disabled={(this.state.voucher.id > 0) ? true : false }
                                onChange={this.handleChange}
                                placeholder="Ingrese nro factura"
                                margin="normal"
                                className="m-0 p-0 mr-2 mt-2"
                                inputProps={{style:{minWidth: 100, fontSize: '0.75rem'}}} 
                                inputComponent={TextMaskCustom}
                                startAdornment={<Typography variant="caption" style={{width: 100}}>Nro factura</Typography>}
                                onBlur={this.autcompleteNumber}
                            />
                            <TextField
                                id="voucher_type_id"
                                name="voucher_type_id"
                                select
                                disabled={(this.state.voucher.id > 0) ? true : false }
                                margin="normal"
                                className={classes.select}
                                InputLabelProps={{
                                    shrink: true
                                }}
                                onChange={this.handleChange}
                                value={this.state.voucher.voucher_type_id}
                                inputProps={{style:{minWidth: 70, fontSize: '0.75rem'}}}
                                InputProps={{
                                    startAdornment: <InputAdornment position="start" ><Typography variant="caption" style={{width: 140}}>Tipo de Comprobante</Typography></InputAdornment>,
                                    style:{fontSize: '0.75rem'}
                                    }}
                            >
                                {this.state.voucher_types.map((option) => (
                                <MenuItem key={option.id} value={option.id} className={classes.typography}>
                                    {option.name}
                                </MenuItem>
                                ))}
                            </TextField>                            


                            <TextField
                                id="reception_date"
                                value={this.state.voucher.reception_date}
                                onChange={this.handleChange}
                                type="date"
                                required
                                name="reception_date"
                                disabled={(this.state.voucher.id > 0) ? true : false }
                                margin="normal"
                                className="m-0 p-0 mr-2 mt-2"
                                InputLabelProps={{
                                    shrink: true
                                }}
                                InputProps={{
                                    startAdornment: <InputAdornment position="start" ><Typography variant="caption" style={{width: 120}}>Fecha de recepcion</Typography></InputAdornment>,
                                }}
                                inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}}
                            />
                            <TextField
                                id="voucher_date"
                                value={this.state.voucher.voucher_date}
                                onChange={this.handleChange}
                                type="date"
                                required
                                disabled={(this.state.voucher.id > 0) ? true : false }
                                name="voucher_date"
                                margin="normal"
                                className="m-0 p-0 mr-2 mt-2"
                                InputLabelProps={{
                                    shrink: true
                                }}
                                InputProps={{
                                    startAdornment: <InputAdornment position="start" ><Typography variant="caption" style={{width: 120}}>Fecha de factura</Typography></InputAdornment>,
                                }}
                                inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}}
                            />
                            <TextField
                                id="created_at"
                                value={this.state.voucher.created_at}
                                onChange={this.handleChange}
                                type="date"
                                required
                                disabled={true}
                                name="created_at"
                                margin="normal"
                                className="m-0 p-0 mr-2 mt-2"
                                InputLabelProps={{
                                    shrink: true
                                }}
                                InputProps={{
                                    startAdornment: <InputAdornment position="start" ><Typography variant="caption" style={{width: 120}}>Fecha de carga</Typography></InputAdornment>,
                                }}
                                inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}}
                            />                       
                            <TextField
                                id="payment_deal"
                                name="payment_deal"
                                margin="normal"
                                disabled
                                type="text"
                                className={classes.select}
                                InputLabelProps={{
                                    shrink: true
                                }}
                                value={payment_deal}
                                inputProps={{style:{fontSize: '0.75rem'}}}
                                InputProps={{
                                    startAdornment: <InputAdornment position="start" ><Typography variant="caption">Termino de pago</Typography></InputAdornment>,
                                    style:{fontSize: '0.75rem'}
                                }}
                            />
                            <TextField
                                id="payment_deal"
                                name="payment_deal"
                                margin="normal"
                                disabled
                                type="date"
                                className={classes.select}
                                InputLabelProps={{
                                    shrink: true
                                }}
                                value={this.state.voucher.due_date}
                                inputProps={{style:{minWidth: 70, fontSize: '0.75rem'}}}
                                InputProps={{
                                    startAdornment: <InputAdornment position="start" ><Typography variant="caption">Fecha de vencimiento</Typography></InputAdornment>,
                                    style:{fontSize: '0.75rem'}
                                    }}
                            />



                        </div>
                        {(this.state.work_orders.map((val, idx)=>{
                            return (
                                <div>
                                    <TextField
                                        id="id"
                                        name="id"
                                        margin="normal"
                                        className="mr-2 mt-1"
                                        InputLabelProps={{
                                            shrink: true
                                        }}
                                        disabled={true}
                                        value={val.id}
                                        inputProps={{style:{fontSize: '0.75rem'}}}
                                        InputProps={{
                                            startAdornment: <InputAdornment position="start" ><Typography variant="caption" ># OT</Typography></InputAdornment>,
                                        }}
                                    />
                                    <TextField
                                        id="plate"
                                        name="plate"
                                        margin="normal"
                                        className="mr-2 mt-1"
                                        InputLabelProps={{
                                            shrink: true
                                        }}
                                        disabled={true}
                                        value={val.vehicle.plate}
                                        inputProps={{style:{fontSize: '0.75rem'}}}
                                        InputProps={{
                                            startAdornment: <InputAdornment position="start" ><Typography variant="caption" >Patente</Typography></InputAdornment>,
                                        }}
                                    />
                                    <TextField
                                        id="reason"
                                        name="reason"
                                        margin="normal"
                                        className="mr-2 mt-1"
                                        InputLabelProps={{
                                            shrink: true
                                        }}
                                        disabled={true}
                                        value={val.reason}
                                        inputProps={{style:{fontSize: '0.75rem'}}}
                                        InputProps={{
                                            startAdornment: <InputAdornment position="start" ><Typography variant="caption" >Descripcion</Typography></InputAdornment>,
                                        }}
                                    />
                                    <TextField
                                        id="total_s_iva_price"
                                        name="total_s_iva_price"
                                        margin="normal"
                                        className="mr-2 mt-1"
                                        InputLabelProps={{
                                            shrink: true
                                        }}
                                        disabled={true}
//											value={(val.tasks.length > 0) ? val.tasks[0].total_s_iva_price : 0}
                                        value={(val.total_s_iva_price) ? val.total_s_iva_price : 0}
                                        inputProps={{style:{fontSize: '0.75rem'}}}
                                        InputProps={{
                                            startAdornment: <InputAdornment position="start" ><Typography variant="caption" >Monto Total</Typography></InputAdornment>,
                                        }}
                                    />
                                    {(val.expand === false || val.expand === undefined)
                                        ?
                                            <ExpandMoreIcon onClick={(e)=>{this.handleExpand(e, idx)}} />
                                        :
                                            <ExpandLessIcon onClick={(e)=>{this.handleCollapse(e, idx)}} />
                                    }
                                    {(val.expand)
                                        ?
                                            (val.created === undefined)
                                            ? 
                                                <div>
                                                    <Table size="small" aria-label="a dense table" style={{width: 'auto', minWidth:'650px'}}>
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell className={classes.tableCell} style={{fontWeight: '550'}} >
                                                                </TableCell>
                                                                <TableCell className={classes.tableCell} style={{fontWeight: '550'}} >Tarea</TableCell>
                                                                <TableCell className={classes.tableCell} style={{fontWeight: '550'}} >Mano de obra s/iva</TableCell>
                                                                <TableCell className={classes.tableCell} style={{fontWeight: '550'}} >Repuestos s/iva</TableCell>
                                                                <TableCell className={classes.tableCell} style={{fontWeight: '550'}} >Total s/iva</TableCell>
                                                                <TableCell className={classes.tableCell} style={{fontWeight: '550'}} >IVA Compras</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                        {val.tasks && val.tasks.map((val, idx2)=>{
                                                            return (
                                                                <React.Fragment>
                                                                <TableRow>
                                                                    <TableCell className={classes.tableCell} style={{fontSize: '0.75rem'}} >
                                                                        <Checkbox
                                                                            name={"checked."+idx2}
                                                                            id={"checked."+idx2}
                                                                            checked={val.checked}
                                                                            onChange={(e)=> {this.handleTaskChange(e,idx)}}
                                                                        />
                                                                    </TableCell>													
                                                                    <TableCell className={classes.tableCell} style={{fontSize: '0.75rem'}} >
                                                                        {val.task.name}
                                                                    </TableCell>	
                                                                    <TableCell className={classes.tableCell} style={{fontSize: '0.75rem'}} >
                                                                        <NumberFormat 
                                                                            id={"workforce_s_iva_price."+idx2}
                                                                            name={"workforce_s_iva_price."+idx2}
                                                                            value={val.workforce_s_iva_price}
                                                                            placeholder="Ingrese la mano de obra"
                                                                            onChange={(e)=> {this.handleTaskChange(e,idx)}}
                                                                            className="m-0 p-0"
                                                                            InputProps={{style: {minWidth: 70,fontSize: '0.75rem'}}}
                                                                            disabled={(!val.task.workforce_account_cost) ? true : false }
                                                                            decimalSeparator='.'
                                                                            prefix={'$'}
                                                                            customInput={TextField}  
                                                                            InputLabelProps={{
                                                                            shrink: true,
                                                                            }}
                                                                            isAllowed={(values) => {
                                                                            let { floatValue } = values;
                                                                            floatValue = (floatValue !== undefined) ? floatValue : 0
                                                                            return floatValue >= 0 && floatValue < 99999999;
                                                                            }}            
                
                                                                            />								          
                                                                    </TableCell>	
                                                                    <TableCell className={classes.tableCell} style={{fontSize: '0.75rem'}} >
                                                                        <NumberFormat 
                                                                            id={"materials_s_iva_price."+idx2}
                                                                            name={"materials_s_iva_price."+idx2}
                                                                            value={val.materials_s_iva_price}
                                                                            placeholder="Ingrese los materiales"
                                                                            onChange={(e)=> {this.handleTaskChange(e,idx)}}
                                                                            className="m-0 p-0"
                                                                            InputProps={{style: {minWidth: 70,fontSize: '0.75rem'}}}
                                                                            disabled={(!val.task.materials_account_cost) ? true : false }
                                                                            decimalSeparator='.'
                                                                            prefix={'$'}
                                                                            customInput={TextField}  
                                                                            InputLabelProps={{
                                                                            shrink: true,
                                                                            }}
                                                                            isAllowed={(values) => {
                                                                            let { floatValue } = values;
                                                                            floatValue = (floatValue !== undefined) ? floatValue : 0
                                                                            return floatValue >= 0 && floatValue < 99999999;
                                                                            }}            
                
                                                                            />								          
                                                                    </TableCell>	
                                                                    <TableCell className={classes.tableCell} style={{fontSize: '0.75rem'}} >
                                                                        <NumberFormat 
                                                                            id={"total_s_iva_price."+idx2}
                                                                            name={"total_s_iva_price."+idx2}
                                                                            value={val.total_s_iva_price}
                                                                            placeholder="Ingrese el total"
                                                                            onChange={(e)=> {this.handleTaskChange(e,idx)}}
                                                                            className="m-0 p-0"
                                                                            InputProps={{style: {minWidth: 70,fontSize: '0.75rem'}}}
                                                                            disabled={(!val.task.total_account_cost) ? true : false }
                                                                            decimalSeparator='.'
                                                                            prefix={'$'}
                                                                            customInput={TextField}  
                                                                            InputLabelProps={{
                                                                                shrink: true,
                                                                            }}
                                                                            isAllowed={(values) => {
                                                                            let { floatValue } = values;
                                                                                floatValue = (floatValue !== undefined) ? floatValue : 0
                                                                                return floatValue >= 0 && floatValue < 99999999;
                                                                            }}            
        
                                                                        />								          
                                                                    </TableCell>
                                                                    <TableCell className={classes.tableCell}>
                                                                        <Select native name={"iva_buy_id."+idx2}
                                                                            inputProps={{
                                                                            name:"iva_buy_id."+idx2,
                                                                            className:"iva_buy_id."+idx2
                                                                            }}
                                                                            value={val.iva_buy_id}
                                                                            style={{fontSize: '0.75rem', width: 70}}
                                                                            onChange={(e)=> {this.handleTaskChange(e,idx)}}
                                                                            required
                                                                            input={<Input id="grouped-native-select" name='contract_id'/>}>
                                                                            <option value="" />
                                                                            {this.state.iva_conditions.buy.map((condition) => <option id={condition.name} value={condition.id}>{condition.name}
                                                                        </option>)}
                                                                        </Select>
                                                                    </TableCell>
                                                                </TableRow>	
                                                            </React.Fragment>
                                                            )
                                                        })}
                                                        </TableBody>
                                                    </Table>
                                                </div>
                                            :
                                                <div>
                                                    <TextField
                                                        id="created"
                                                        name="created"
                                                        margin="normal"
                                                        className="mr-2 mt-1"
                                                        InputLabelProps={{
                                                            shrink: true
                                                        }}
                                                        disabled={true}
                                                        value="Si"
                                                        inputProps={{style:{fontSize: '0.75rem'}}}
                                                        InputProps={{
                                                            startAdornment: <InputAdornment position="start" ><Typography variant="caption" >Facturada</Typography></InputAdornment>,
                                                        }}
                                                    />
                                                </div>
                                            :
                                            ''
                                    }

                                </div>
                            )
                        }))}
                    </div>
                    <div className="row mt-2 ml-4">
                        <MediaFile onChange={this.handleUploadFile} title="Agregar comprobante" width={"15rem"} height={"2rem"}  meta_data="comprobante" files={this.state.files}/>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <Button disabled={this.state.saving}className="mt-3" variant="contained" color="primary" size="small" style={{fontSize: '0.75rem'}} onClick={(e)=>{this.handleSubmit(e)}}>Cargar comprobante</Button>
                        </div>
                    </div>

                </Container>
                <Snackbar open={this.state.snackbar.open} onClose={this.handleSnackbar}>
                    <Alert onClose={this.handleSnackbar} severity={this.state.snackbar.severity}>
                        {this.state.snackbar.success_message}
                    </Alert>
                </Snackbar>

            </React.Fragment>
        );
    }
}

export default withStyles(useStyles)(MultipleVoucher);